<template>
  <div class="footer l:hidden fixed">
    <div class="action-bar padding-m-vertical flex">
      <icon icon="footer-video" />
      <icon icon="footer-mail" />
      <icon icon="footer-chat" />
    </div>
  </div>
  <div class="l:hidden spacer"></div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  background-color: var(--c-bg);
  height: 50px;
  bottom: 0;
  z-index: 10;
}

.action-bar {
  justify-content: space-around;
  height: 100%;
  align-items: center;
}

i {
  height: 17px !important;
  width: 28px !important;
  flex-basis: auto !important;
}

.spacer {
  margin-bottom: 50px;
}
</style>
